<template>
	<div class="vstack gap-1">
		<div class="h5 fw-bold">Historial de cambios</div>
		<ul class="list-group list-group-flush list-group-borderless">
			<template v-if="histories.length > 0">
				<CustomerCommonHistoryRow v-for="history in histories" :key="history.id" :history="history" />
			</template>
			<template v-else>
				<li class="list-group-item lh-sm">
					No se encontraron cambios.
				</li>
			</template>
		</ul>
	</div>
</template>

<script>
	export default {
		props: {
			histories: Array
		}
	}
</script>